<app-grid-layout withExport (export)="exportAsCsv()">
  <ag-grid-angular
    style="width: 100%; height: 100%"
    class="grid-height"
    [rowData]="brandAliases()"
    [gridOptions]="gridOptions"
  />
</app-grid-layout>
